import { render, staticRenderFns } from "./StoreInfo.vue?vue&type=template&id=45901b51&scoped=true"
import script from "./StoreInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./StoreInfo.vue?vue&type=script&setup=true&lang=js"
import style0 from "./StoreInfo.vue?vue&type=style&index=0&id=45901b51&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45901b51",
  null
  
)

export default component.exports